var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelope(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.87868 1.54531C0 2.42399 0 3.8382 0 6.66663V13.3333C0 16.1617 0 17.5759 0.87868 18.4546C1.75736 19.3333 3.17157 19.3333 6 19.3333H18C20.8284 19.3333 22.2426 19.3333 23.1213 18.4546C24 17.5759 24 16.1617 24 13.3333V6.66663C24 3.8382 24 2.42399 23.1213 1.54531C22.2426 0.666626 20.8284 0.666626 18 0.666626H6C3.17157 0.666626 1.75736 0.666626 0.87868 1.54531ZM4.5547 5.16791C4.09517 4.86156 3.4743 4.98573 3.16795 5.44526C2.8616 5.90479 2.98577 6.52566 3.4453 6.83201L10.8906 11.7955C11.5624 12.2434 12.4376 12.2434 13.1094 11.7955L20.5547 6.83201C21.0142 6.52566 21.1384 5.90479 20.8321 5.44526C20.5257 4.98573 19.9048 4.86156 19.4453 5.16791L12 10.1314L4.5547 5.16791Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/envelope.0832d829348c27974583e08f8f366784.svg";
export { ForwardRef as ReactComponent };